import { Config } from 'config';
import {
  getSsoStateNonce,
  saveSsoStateNonce,
  clearSsoStateNonce,
} from 'utils/storage';

export const generateSsoStateNonce = (): string => {
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

export { getSsoStateNonce, saveSsoStateNonce, clearSsoStateNonce };

const decodeJwtSegment = (value: string): string => {
  const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
  const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');

  return atob(padded);
};

export const getSsoStateNonceFromJwt = (state: string): string | null => {
  const segments = state.split('.');
  if (segments.length < 2) {
    return null;
  }

  try {
    const payload = JSON.parse(decodeJwtSegment(segments[1])) as {
      nonce?: unknown;
    };

    return typeof payload.nonce === 'string' && payload.nonce
      ? payload.nonce
      : null;
  } catch {
    return null;
  }
};

export const isTrustedSsoAuthorizeUrl = (authorizeUrl: string): boolean => {
  try {
    const parsed = new URL(authorizeUrl);
    const hostname = parsed.hostname.toLowerCase();
    const hostnameIsAllowed = Config.ssoAuthorizeHosts.some(
      (allowedHost: string) =>
        hostname === allowedHost || hostname.endsWith(`.${allowedHost}`)
    );

    return (
      parsed.protocol === 'https:' &&
      parsed.pathname === '/authorize' &&
      hostnameIsAllowed
    );
  } catch {
    return false;
  }
};
